export const blockIconsHomeNestCamIndoorNew = (
	<span className='material-symbols-outlined'>nest_cam_indoor</span>
);
